import { onContactSupport } from '@va/dashboard/util-helpers/misc';
import { BackIconRounded, CustomerSupport } from '@va/icons';
import { useTranslate } from '@va/localization';
import { Button, Heading1, Paragraph, fontWeights, paragraphSizes } from '@va/ui/design-system';
import classNames from 'classnames';

export const MissingItemErrorView = ({
  message,
  title,
  className,
  onGoBackClick,
  icon,
}: {
  className?: string;
  message: string;
  title: string;
  onGoBackClick?: () => void;
  icon?: React.ReactNode;
}) => {
  const translate = useTranslate();

  return (
    <div className={classNames('text-center flex flex-col justify-center items-center p-3', className)}>
      <div className='relative mb-9'>
        <div
          className='w-120px h-[7.5rem] rounded-full border-[0.25rem] border-dotted border-gray-dusty animate-spin'
          style={{ animationDuration: '8s' }}
        ></div>
        <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-22.5 h-22.5 rounded-full bg-white-snow'>
          {icon}
        </div>
      </div>
      <Heading1 weight={fontWeights.semibold} className='mb-6px' colorClassName='text-gray-code'>
        {title}
      </Heading1>
      <Paragraph colorClassName='text-gray-devil' className='mb-24px' size={paragraphSizes.large}>
        {message}
      </Paragraph>
      <div className='flex flex-col sm-initial:flex-row items-center gap-3 w-full max-w-112.5 '>
        {onGoBackClick && (
          <Button
            onClick={onGoBackClick}
            color='tertiary'
            className='flex-1 justify-center w-full'
            text={'Go Back'}
            icon={(_, color) => <BackIconRounded color={color} />}
          />
        )}
        <Button
          onClick={onContactSupport}
          className='flex-1 justify-center w-full'
          icon={() => <CustomerSupport color={'#3c3c3c'} />}
          text={translate('button.contactSupport')}
          color='tertiary'
        />
      </div>
    </div>
  );
};
